export * from './get-device.params';
